import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV } from "@/constants/testIds";

const links = [
  { label: "Ethos", href: "#manifesto", id: NAV.linkAbout },
  { label: "Products", href: "#products", id: NAV.linkProducts },
  { label: "Industries", href: "#industries", id: NAV.linkIndustries },
  { label: "Contact", href: "#contact", id: NAV.linkContact },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    on();
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.76, 0, 0.24, 1] }}
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#faf9f6]/85 backdrop-blur-xl border-b border-[#e5e3d8]"
          : "bg-transparent"
      }`}
    >
      <div className="flex justify-between items-center px-5 lg:px-10 py-4">
        <a
          href="#top"
          data-testid={NAV.logo}
          className="flex items-center group"
        >
          <img
            src="/products/logo-full.png"
            alt="SconeCORE Enterprises"
            className="h-9 md:h-11 w-auto object-contain"
          />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={l.id}
              className="link-wipe overline text-[#0A2A1E]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid={NAV.ctaContact}
            className="btn-primary"
          >
            Request a Sample
          </a>
        </nav>

        <button
          className="md:hidden text-[#0A2A1E]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="md:hidden border-t border-[#e5e3d8] overflow-hidden bg-[#faf9f6]"
          >
            <div className="flex flex-col p-6 gap-5">
              {links.map((l) => (
                <a
                  key={l.label}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="font-display text-3xl text-[#0A2A1E]"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                className="btn-primary self-start mt-2"
              >
                Request a Sample
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Header;
